import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_CONTACT_DETAILS: MijnRoute = {
    path: 'contactgegevens-beheren',
    navigationEvent: 'toContactgegevensBeheren',
    regex: /^\/zelf-regelen\/contactgegevens-beheren$/,
    webcomponent: 'mijn-klant-contactgegevens-webcomponent'
};
